import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '..';

export interface IApp {
	loading?: number;
	drawer?: boolean;
	backdrop?: boolean;
}

const initialState: IApp = {
	loading: 0,
	drawer: true,
	backdrop: false
};

export const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			const currentLoading = state.loading;
			state.loading = action.payload ? currentLoading + 1 : currentLoading - 1;
		},
		setDrawer: (state, action: PayloadAction<boolean>) => {
			state.drawer = action.payload;
		},
		setBackdrop: (state, action: PayloadAction<boolean>) => {
			state.backdrop = action.payload;
		},
	},
});

export const {setLoading, setDrawer, setBackdrop} = appSlice.actions;

export const selectLoading = (state: RootState): IApp => state.app;
export const selectDrawer = (state: RootState): boolean => state.app.drawer;
export const selectBackdrop = (state: RootState): boolean => state.app.backdrop;

export default appSlice.reducer;
